import { proxyAction } from './proxyAction.js';

/**
 * 代理接口请求类
 * 专门处理 /group 和 /h5 开头的 API 请求
 * 参考 cloudRequest.js 的实现方式
 */
export default class proxyRequest {
    /**
     * 获取请求的完整URL
     */
    static getFullUrl(address) {
        // 开发环境通过 vue.config.js 代理，直接使用相对路径
        return address.startsWith('/') ? address : `/${address}`;
    }

    /**
     * GET 请求
     */
    static get(address, params) {
        const url = this.getFullUrl(address);
        return proxyAction({
            url,
            method: 'get',
            params: params || {},  // 代理接口不添加 TenantCode
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionStorage.getItem('token')
                    ? `Bearer ${JSON.parse(sessionStorage.getItem('token'))}`
                    : ''
            }
        });
    }

    /**
     * POST 请求
     */
    static post(address, data) {
        const url = this.getFullUrl(address);
        return proxyAction({
            url,
            method: 'post',
            data: data,  // 代理接口不添加 TenantCode
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionStorage.getItem('token')
                    ? `Bearer ${JSON.parse(sessionStorage.getItem('token'))}`
                    : ''
            }
        });
    }
}
